export default {
	namespaced: true,
	state: () => ({
		bubbles: [],
		task: {},
		marquee: [],
		bubblesCountDown: '00:00:00',
		interestBubblesCountDown: '00:00:00',
		isHadClickBubbles: false,
		rules: [],
		pop: {},
		taskList: [],
		signInInfo: {},
		goldPigInfo: {},
		businessName: '',
		businessNameDouble: '',
		currentPriceModalInfo: {
			type: '',
			reward: '',
		},
		withdrawPageInfo: {
			amount: '',
			channel_list: [],
			invite_txt_info: {},
		},
		channelList: [],
		selectWithdrawChannel: {},
		selectWithdrawChannelIndex: [0, 0],
		amountFromNum: 0,
		amountToNum: 0,
		experiencePageAb: 'b',
		inviteTxtInfo: {},
	}),
	mutations: {
		SetPageInfo(state, playLoad) {
			let { bubbles, task, marquee, rules, sign_in_info, business_name, business_name_double, pop, task_list, invite_txt_info } = playLoad;

			bubbles && this.commit('fission/ExperienceGold/SetBubbles', bubbles);
			task && this.commit('fission/ExperienceGold/SetTaskInfo', task);
			sign_in_info && this.commit('fission/ExperienceGold/SetSignInfo', sign_in_info);
			invite_txt_info && this.commit('fission/ExperienceGold/SetInviteTxtInfo', invite_txt_info);

			marquee && (state.marquee = marquee);
			rules && (state.rules = rules);
			business_name && (state.businessName = business_name);
			business_name_double && (state.businessNameDouble = business_name_double);
			pop && (state.pop = pop);
			task_list && (state.taskList = task_list);
		},
		SetSignInfo(state, playLoad) {
			state.signInInfo = playLoad;
		},
		SetTaskInfo(state, playLoad) {
			state.task = playLoad;
		},
		SetBubbles(state, playLoad) {
			state.bubbles = playLoad;
		},
		SetBubblesCountDown(state, playLoad) {
			state.bubblesCountDown = playLoad;
		},
		SetInterestBubblesCountDown(state, playLoad) {
			state.interestBubblesCountDown = playLoad;
		},
		SetGoldPigInfo(state, playLoad) {
			state.goldPigInfo = playLoad;
		},
		SetCurrentPriceModalInfo(state, playLoad) {
			state.currentPriceModalInfo = playLoad;
		},
		SetWithdrawPageInfo(state, playLoad) {
			state.withdrawPageInfo = playLoad;
			let { channel_list, invite_txt_info } = playLoad;
			channel_list && this.commit('fission/ExperienceGold/SetChannelList', channel_list);
			invite_txt_info && this.commit('fission/ExperienceGold/SetInviteTxtInfo', invite_txt_info);
		},
		SetChannelList(state, playLoad) {
			state.channelList = playLoad;
		},
		SetSelectWithdrawChannel(state, playLoad) {
			state.selectWithdrawChannel = playLoad;
		},
		SetSelectWithdrawChannelIndex(state, playLoad) {
			state.selectWithdrawChannelIndex = playLoad;
		},
		SetAmountFromNum(state, playLoad) {
			state.amountFromNum = playLoad;
		},
		SetAmountToNum(state, playLoad) {
			state.amountToNum = playLoad;
		},
		SetInviteTxtInfo(state, playLoad) {
			state.inviteTxtInfo = playLoad;
		},
	},
	actions: {},
	getters: {
		Marquee(state) {
			return state.marquee;
		},

		TaskInfo(state) {
			return state.task;
		},
		Bubbles(state) {
			return state.bubbles;
		},
		BubblesCountDown(state) {
			return state.bubblesCountDown;
		},
		InterestBubblesCountDown(state) {
			return state.interestBubblesCountDown;
		},
		Rules(state) {
			return state.rules;
		},
		SignInInfo(state) {
			return state.signInInfo;
		},
		GoldPigInfo(state) {
			return state.goldPigInfo;
		},
		BusinessName(state) {
			return state.businessName;
		},
		CurrentPriceModalInfo(state) {
			return state.currentPriceModalInfo;
		},
		WithdrawPageInfo(state) {
			return state.withdrawPageInfo;
		},
		SelectWithdrawChannel(state) {
			return state.selectWithdrawChannel;
		},
		BusinessNameDouble(state) {
			return state.businessNameDouble;
		},
		Pop(state) {
			return state.pop;
		},
		TaskList(state) {
			return state.taskList;
		},
		AmountToNum(state) {
			return state.amountToNum;
		},
		AmountFromNum(state) {
			return state.amountFromNum;
		},
		InviteTxtInfo(state) {
			return state.inviteTxtInfo;
		},
		ChannelList(state) {
			return state.channelList;
		},
		SelectWithdrawChannelIndex(state) {
			return state.selectWithdrawChannelIndex;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/Fission/module/experience-gold.js